import * as moment from 'moment-timezone';
import { GroupEmail } from './AdminInterface';
import { IDispatchConfirm, IDispatchTruck } from './DispatchInterface';
import { IUser } from './UserInterface';
import { IRegion } from './WellInterface';

const eStr = '' as unknown as number;

class ISolidsControl {
    public id: string = "";
    public sizeScreens: string = '';
    public deviceName: string = '';
    public inUse: boolean = true;
    public hoursTourly: number = eStr;
    public quantity: number = eStr;
    public ordinal: number = 0;
    public createdTestId: string = '';
}

class ITestContact {
    public id: string = "";
    public contactTypeName: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public phoneMobile: string = '';
    public phoneWork: string = '';
    public email: string = '';
    public otherTypeName: string = '';
    public available: string = '';
    public onJob: boolean = true;
    public emailDefaultOn: boolean = true;
}

class IInterval {
    public id: string = "";
    public intervalType: string = '';
    public subInt: string = '';
    public active: boolean = true;
    public estHoleSize: number = eStr;
    public topFt: number = eStr;
    public topFtTVD: number = eStr;
    public bottomFt: number = eStr;
    public depthTVD: number = eStr;
    public plugBackDepth: number = eStr;
    public plugBackDepthTVD: number = eStr;
    public capBblLinFt: number = 0;
    public casingOD: number = eStr;
    public casingID: number = eStr;
    public casingTop: number = eStr;
    public casingBottom: number = eStr;
    public casingTopTVD: number = eStr;
    public casingBottomTVD: number = eStr;
    public ordinal: number = eStr;
    public status: string = '';
    public startDate: string = moment(new Date()).unix().toString();
    public stopDate: string = '';
    public cumBaseOilUsed: number = 0;
    public createdTestId: string = '';
    public casings: IIntervalCasing[] = [];
}

class IIntervalCasing {
    public id: string = "";
    public createdWellTestId = "";
    public capBblLinFt: number = 0;
    public casingOD: number = eStr;
    public casingID: number = eStr;
    public casingTop: number = eStr;
    public casingBottom: number = eStr;
    public casingTopTVD: number = eStr;
    public casingBottomTVD: number = eStr;
    public ordinal: number = eStr;
}

class ISurvey {
    public id: string = "";
    public depthMD: number = eStr;
    public depthTVD: number = eStr;
    public inclination: number = eStr;
    public azimuth: string = '';
    public surveyDateTime: number = 0;
    public preSurveyDateTime: any = new Date();
    public testDateTime: string = '';
    public createdWellTestId: string = '';
}

class IDrillString {
    public id: string = "";
    public itemType: string = '';
    public itemTypeShortName: string = '';
    public lookUpAvailable: boolean = true;
    public description: string = '';
    public innerDiameter: number = eStr;
    public outerDiameter: number = eStr;
    public length: number = eStr;
    public cap: number = 0;
    public disp: number = 0;
    public ordinal: number = 0;
}

class IBitData {
    public id: string = "";
    public rpm: number = eStr;
    public rop: number = eStr;
    public wob: number = eStr;
    public torqueMax: number = eStr;
    public estHoleSize: number = eStr;
    public ecd: number = eStr;
    public nozzleVelocity: number = eStr;
    public jetImpactForce: number = eStr;
    public hydraulicHorsepower: number = 0;
    public pressureDrop: number = 0;
    public percentPressureDrop: number = 0;
    public surgePressure: number = 0;
    public swabPressure: number = 0;
    public nValue: number = 0;
    public kValue: number = 0;
    public reynoldsNumber: number = 0;
    public tripSpeed: number = eStr;
    public isPipeClosed: boolean = false;
    public washout: string = '';
    public bits: IDrillBit[] = [];
}

class IDrillBit {
    public id: string = "";
    public bitNumber: number = 0;
    public bitSize: number | string = '';
    public make: string = '';
    public model: string = '';
    public bitType: string = '';
    public depthIn: number | string = '';
    public depthOut: number = 0;
    public tfa: number = 0;
    public reRun: boolean = false;
    public jetSizes: Array<number | string> = [];
    public createdWellTestId: string = '';
}

class IPumpData {
    public id: string = "";
    public pumps: IPump[] = [];
    public circPressure: number = eStr;
    public surfaceToBitStks: number = 0;
    public bottomsUpStks: number = 0;
    public surfaceToSurfaceStks: number = 0;
    public activeVolumeStks: number = 0;
    public surfaceToBitMinutes: number = 0;
    public bottomsUpTime: number = 0;
    public surfaceToSurfaceMinutes: number = 0;
    public activeVolumeMinutes: number = 0;
    public avdp: number = 0;
    public avdc: number = 0;
    public criticalVelocity: number = 0;
    public flowType: string = '';
    public totalStksMin: number = 0;
    public totalBblMin: number = 0;
    public totalGalMin: number = 0;
    public pitVolume: number = 0;
    public surfaceToBitBarrels: number = 0;
    public bottomsUpBarrels: number = 0;
    public surfaceToSurfaceBarrels: number = 0;
    public activeVolumeBarrels: number = 0;
    public volumeBelowBit: number = 0;
    public holeCapacity: number = 0;
}

class IPump {
    public id: string = "";
    public pumpNumber: number = 0;
    public make: string = '';
    public model: string = '';
    public linerQty: number = eStr;
    public linerSize: number = eStr;
    public stkLength: number = eStr;
    public rodSize: number = eStr;
    public efficiency: number = 100;
    public stkMin: number = eStr;
    public bblStk: number = 0;
    public bblMin: number = 0;
    public galMin: number = 0;
    public onJob: boolean = true;
    public createdWellTestId: string = '';
}

class IMudProperties {
    public id: string = "";
    public wellTestId: string = '';
    public isOilBasedMud: boolean = false;
    public sampleSource: string = '';
    public sampleSourceTime: number = 0;
    public weightingAgentId: string = '';
    public otherTime: any;
    public flowLineTemp: number = 0;
    public mudWeight: number = 0;
    public funnelViscosity: number = 0;
    public funnelViscosityDefF: number = 0;
    public rpmDegF: number = 0;
    public rpmDegF600: number = 0;
    public rpmDegF300: number = 0;
    public rpmDegF200: number = 0;
    public rpmDegF100 : number = 0;
    public rpmDegF6 : number = 0;
    public rpmDegF3 : number = 0;
    public gelStrength10sec : number = 0;
    public gelStrength10min : number = 0;
    public gelStrength30min : number = 0;
    public filtrateApi : number = 0;
    public filtrateHthp : number = 0;
    public cakeThicknessApi : number = 0;
    public cakeThicknessHthp : number = 0;
    public mudTempApi : number = 0;
    public mudTempHthp : number = 0;
    public retortContentWater : number = 0;
    public retortContentOil : number = 0;
    public retortContentSolids : number = 0;
    public chlorideMgL : number = 0;
    public cacl2wps : any = '';
    public sandContent : number = 0;
    public methyleneBlueTest : number = 0;
    public pHReading : number = 0;
    public mudAlkalinityPm : number = 0;
    public filtrateAlkalinityPf : number = 0;
    public filtrateAlkalinityMf : number = 0;
    public totalHardness : any = '';
    public totalHardnessMl: any = '';
    public calcium : any = '';
    public calciumMl : any = '';
    public magnesium : any = '';
    public excessLime : number = 0;
    public oilWaterRatioFrom : number = 0;
    public oilWaterRatioTo : number = 0;
    public mudAlkalinityPom : number = 0;
    public limeContent : number = 0;
    public versenate : number = 0;
    public saltContentWaterPhase : number = 0;
    public chlorideClsn : number = 0;
    public electricalStability : number = 0;
    public lcm : number = 0;
    public optionalField1Name: string = '';
    public optionalField1Value : number = 0;
    public optionalField2Name: string = '';
    public optionalField2Value : number = 0;
    public fluidType: string = '';
    public mudWeightPpg : string = '';
    public viscositySecQt : string = '';
    public mudPropOption1: string = '';
    public mudPropValue1: string = '';
    public mudPropOption2: string = '';
    public mudPropValue2: string = '';
    public mudPropOption3: string = '';
    public mudPropValue3: string = '';
    public plasticViscosity : number = 0;
    public yeildPoint : number = 0;
    public mudGradient : number = 0;
    public hydrostaticPsi : number = 0;
    public ecd : number = 0;
    public surgePressure : number = 0;
    public swabPressure : number = 0;
    public nValue : number = 0;
    public kValue : number = 0;
    public reynoldsNbr : number = 0;
    public asg : number = 0;
    public lowGravityPcnt : number = 0;
    public lowGravityLbBbl : number = 0;
    public highGravityPcnt : number = 0;
    public highGravityLbBbl : number = 0;
    public bentonitePcnt : number = 0;
    public bentoniteLbBbl : number = 0;
    public drillSolidsPcnt : number = 0;
    public drillSolidsLbBbl : number = 0;
    public saltVolumeAdjPcnt: number = 0;
    public saltVolumePcnt : number = 0;
    public oilSg : number = 0;
    public wghtMatlSg : number = 0;
    public drillSolidsSg : number = 0;
    public cationExchangeCapacity: number = 0;
    public unweightedASG : number = 2.6;
    public showNormalASG : boolean = false;
    public effectiveViscosity: number = 0;

    public drillSolidsSgOverride : boolean = false;
    public wghtMatlSgOverride : boolean = false;
    public oilSgOverride : boolean = false;

}

class IRemarks {
    public id: string = "";
    public previousTourlyTreatment: string = '';
    public tourlyTreatment: string = '';
    public tourlyTreatmentChanges: string = '';
    public mudReportRecap: string = '';
    public additional: string = '';
    public internal: string = '';
    public recapSuggestion: string = '';
    public additionalRecapSuggestion: string = '';
    public wellStories: IWellStory[] = [];
}

class IWellStory {
    public id: string = "";
    public createdWellTestId: string = '';
    public remarkText: string = '';
    public remarkSubType: string = '';
    public remarkSubmittedDate: string = '';
    public createUserId: string = '';
}

class IInventoryTotal {
    public id: string = "";
    public productTotal: number = 0;
    public productTax: number = 0;
    public otherCosts: number = 0;
    public otherCostTax: number = 0;
    public dailyTotal: number = 0;
    public cumulativeTotal: number = 0;
    public prevCumulativeTotal: number = 0;
    public productTaxRate: number = 0;
    public rentalTaxRate: number = 0;
    public serviceTaxRate: number = 0;
}

class IInventoryProduct {
    public id: string = "";
    public priceUsed: number = 0;
    public startingAmount: number = 0;
    public adjustedStartingAmount: number = 0;
    public amountReceived: number = 0;
    public amountReturned: number = 0;
    public closingAmount: number = 0;
    public writeOffAmount: number = 0;
    public amountUsed: number = 0;
    public cumulativeAmountUsed: number = 0;
    public totalCost: number = 0;
    public cumulativeCost: number = 0;
    public isInventoryAdjustment: false;
    public isTaxable: boolean = true;
    public product: IProduct = new IProduct();
    public category: IProductCategory = new IProductCategory();
    public categoryId: string = "";
    public reallocation: number = eStr;
    public defaultSortOrdinal: number = 0;
}

class IProduct {
    public id: string = '';
    public erpId: string = '';
    public isMasterListApproved: boolean = true;
    public name: string = '';
    public size: string = '';
    public unit: string = '';
    public weight: string = '';
    public specificGravity: string = '';
    public retailPrice: number = 0;
    public cost: number = 0;
    public isTaxable: boolean = true;
    public isBulk: boolean = false;
    public categorys: IProductCategory[] = [];
    public regions: IRegion[] = [];
}

class IProductCategory {
    public id: string = '';
    public name: string = '';
    public description: string = '';
}

class IInventoryEBP {
    public id: string = "";
    public name: string = '';
    public referenceNumber: string = '';
    public expenseType: IEBPExpenseType = new IEBPExpenseType();
    public unit: string = '';
    public unitPrice: number = 0;
    public totalCost: number = 0;
    public quantity: number = 0;
    public isRecurring: boolean = true;
    public isTaxable: boolean = true;
    public active: boolean = true;
    public reallocation: number = eStr;
    public defaultSortOrdinal: number = 0;
}

class IEBPExpenseType {
    public id: string = '';
    public name: string = '';
    public isRental: boolean = false;
    public isTaxable: boolean = true;
    public cost: number = 0;
    public retailPrice: number = 0;
    public dispatchable: boolean = false;
    public regions: IRegion[] = [] as IRegion[];
}

class IVolumeAccounting {
    public id: string = '';
    public trackWaterBasedVolume: boolean = true;
    public newHoleVolume: number = 0;
    public previousHoleCapacity: number = 0;
    public footageDrilled: number = 0;
    public displacement: number = 0;
    public plantVolRecvd: number = 0;
    public plantVolReturned: number = 0;
    public volOwedToPlant: number = 0;
    public previousVolOwedToPlant: number = 0;
    public otherTransfer: number = 0;
    public otherReceived: number = 0;
    public previousTotalHoleVolume: number = 0;
    public previousDepthMD: number = 0;
    public fluidChanged: boolean = false;

    public startingBaseOil: number = 0;
    public baseOilReceived: number = 0;
    public baseOilUsed: number = 0;
    public endingBaseOil: number = 0;
    public cumBaseOilUsed: number = 0;
    public prevCumBaseOilUsed: number = 0;
    public lostToCuttingsRatio: number = 0;

    public baseOil: number = 0;
    public water: number = 0;
    public chemicalAdditions: number = 0;
    public remainingChemicalAdditions: number = 0;
    public slurry: number = 0;
    public washout: number = 0;
    public xferFromStorage: number = 0;
    public otherAdditions: number = 0;
    public totalAdditions: number = 0;

    public lossToFormation: number = 0;
    public lossToSurface: number = 0;
    public solidsControl: number = 0;
    public lossToCuttings: number = 0;
    public mudLeftInHole: number = 0;
    public otherLoss: number = 0;
    public totalLosses: number = 0;

    public totalHoleVolume: number = 0;
    public pvt: number = 0;
    public externalStorage: number = 0;
    public totalVolume: number = 0;
    public requiredReconciliation: number = 0;
    public previousExternalStorage: number = 0;

    public totalHoleVolumeUserOverride: boolean = false;
    public chemicalAdditionsUserOverride: boolean = false;
    public externalStorageUserOverride: boolean = false;
    public volOwedToPlantUserOverride: boolean = false;
    public propertyTypeCumBaseOilUseds: IPropertyTypeCumBaseOilUsed[] = [];

}

class IPropertyTypeCumBaseOilUsed {
    public propertyType: string = '';
    public cumBaseOilUsed: number = 0;
}

class IExternalStorage {
    public id: string = '';
    public number: number = 0;
    public storageType: string = '';
    public capacity: number = 0;
    public fluidType: string = '';
    public fluidSubType: string = '';
    public previousFluidAmount: number = 0;
    public todayFluidAmount: number = 0;
    public xferIn: string = '';
    public xferOut: string = '';
    public mudWeight: string = '';
    public other: string = '';
    public inUse: boolean = true;
    public defaultSortOrdinal: number = 0;
}

interface ITestApproval{
    id: string;
    wellId: string;
    wellName: string;
    testDate: number;
    timeZoneName: string;
    submittedForApproval: number;
    submittedForApprovalByUser: string;
    currentIntervalType: string;
    testStatus: string;
}

class ITest {

    
    public id: string = '';
    public wellId: string = '';
    public updateUserId: string = '';
    public testStatus: string = '';
    public isInventoryReport: boolean;
    public isNewIntervalReport: boolean;
    public isVolumeAccountingReport: boolean;
    public testDate: number = 0;
    public preTestDate: any;
    public depthMD: number = 0;
    public depthTVD: number = 0;
    public depthBit: number = 0;
    public presentActivity: string = '';
    public mudProperty: string = '';
    public propertyType: string = '';
    public submittedDate: number;
    public kopMD: number = 0;
    public kopTVD: number = 0;
    public eocMD: any = '';
    public eocTVD: number = 0;
    public solidsControlEquips: ISolidsControl[] = [];
    public operatorContacts: ITestContact[] = [];
    public contractorContacts: ITestContact[] = [];
    public otherContacts: ITestContact[] = [];
    public intervals: IInterval[] = [];
    public surveys: ISurvey[] = [];
    public drillStringAssembly: IDrillString[] = [];
    public bitData: IBitData = new IBitData();
    public pumpData: IPumpData = new IPumpData();
    public mudProperties: IMudProperties = new IMudProperties();
    public remarks: IRemarks = new IRemarks();
    public inventoryTotal: IInventoryTotal = new IInventoryTotal();
    public productInventorys: IInventoryProduct[] = [];
    public ebpInventorys: IInventoryEBP[] = [];
    public volumeAccounting: IVolumeAccounting = new IVolumeAccounting();
    public externalStorage: IExternalStorage[] = [];
    public weighted?: boolean | string | null;
    public internalEmails: IWellTestGroupEmail[] = [];
    public mudReportCreateUser?: IUser;
    public deliveriesPending: IDispatchConfirm[];
    public pickupsPending: IDispatchConfirm[];
    public dispatchTrucksReceived: IDispatchTruck[];
    public dispatchTrucksReturned: IDispatchTruck[];
    // Fluid Type is only for test list
    public fluidType: string;
}


class IWellTestGroupEmail extends GroupEmail {
    public emailDefaultOn: boolean = true;
    public groupEmailId: string = '';
}

interface IMudReportProps {
    test: ITest;
}

interface IDrillStringItemType {
    id: string;
    name: string;
    shortName: string;
    description: string;
}
export { ISolidsControl, ITestContact, IIntervalCasing, IInterval, ISurvey, IDrillString, IDrillStringItemType, IBitData, IDrillBit, IPumpData, IPump, IMudProperties, IMudReportProps, IRemarks, IWellStory, IInventoryTotal, IInventoryProduct, IProduct, IProductCategory, IInventoryEBP, IEBPExpenseType, IVolumeAccounting, IExternalStorage, ITest, ITestApproval, IWellTestGroupEmail };




// WEBPACK FOOTER //
// ./src/Interfaces/TestInterface.tsx